import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var PackagePlus = function PackagePlus(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20.5 7.2778 12 12.0001m0 0L3.5 7.2778m8.5 4.7223v9.5m2-.6111-1.223.6794c-.2836.1576-.4254.2363-.5755.2672a1 1 0 0 1-.4029 0c-.1502-.0309-.292-.1096-.5756-.2672l-7.4-4.1111c-.2995-.1664-.4493-.2496-.5584-.368a1 1 0 0 1-.2141-.3639C3 16.5726 3 16.4013 3 16.0586v-8.117c0-.3427 0-.514.0505-.6668a1 1 0 0 1 .2141-.364c.109-.1183.2588-.2015.5584-.368l7.4-4.111c.2836-.1576.4254-.2364.5756-.2673a1 1 0 0 1 .4029 0c.1501.031.2919.1097.5755.2673l7.4 4.111c.2996.1665.4493.2497.5584.368a1 1 0 0 1 .2141.364c.0505.1528.0505.324.0505.6667v4.5586m-13.5-8 9 5M19 21v-6m-3 3h6"
    })
  }));
};
export default PackagePlus;